export const pt = {
  navbar: {
    projects: 'Projetos',
    carbonPackages: 'Pacotes de Créditos',
    retirements: 'Aposentadorias',
    moreInfo: 'Mais informações',
    accessPlatform: 'Acessar Plataforma'
  },
  hero: {
    title: 'Crédito de Carbono de Alta Qualidade para um novo planeta.',
    subtitle: 'Juntos reduziremos os níveis de gás carbônico da atmosfera através da tecnologia e apoio entre empresas e produtores rurais.',
    ctaButton: 'Começar Agora'
  },
  carbonAssets: {
    title: 'Pacotes de Créditos',
    subtitle: 'Explore nossa coleção de créditos de carbono verificados e certificados, contribuindo para um futuro mais sustentável.',
    viewDetails: 'Ver Detalhes',
    wilderSocialCarbonDetails: 'Wilder Earth - Social Carbon',
    purchaseRequest: 'Solicitar Compra',
    loading: 'Carregando ativos...',
    error: 'Erro ao carregar os ativos',
    noAssets: 'Nenhum projeto da VERT ECOTECH SA foi encontrado.',
    standard: 'Padrão',
    vintage: 'Vintage',
    projectType: 'Tipo de Projeto',
    createdDate: 'Data de Criação',
    credits: 'créditos',
    clickDetails: 'Clique para ver detalhes',
    nameNotAvailable: 'Nome não disponível',
    typeNotSpecified: 'Tipo não especificado'
  },
  carbonRetirements: {
    eyebrow: 'Transparência',
    title: 'Compensações',
    subtitle: 'Acompanhe as aposentadorias e compensações realizadas pela VERT ECOTECH SA, contribuindo para a neutralização de emissões e projetos de sustentabilidade.',
    statusRetired: 'Aposentado',
    projectType: 'Tipo de projeto',
    createdDate: 'Data',
    beneficiary: 'Beneficiário',
    retiree: 'Retirante',
    purpose: 'Propósito',
    creditsRetired: 'créditos compensados',
    viewCertificate: 'Ver certificado',
    viewTxid: 'Wilder Earth - Social Carbon',
    viewBlockExplorer: 'Explorador Wilder — TXID',
    txidCopiedTitle: 'TXID copiado',
    txidCopiedMessage:
      'O TXID foi copiado para a área de transferência. Na página do explorador que abriu, pressione Ctrl+V (ou Cmd+V no Mac) para colar e buscar a transação.',
    txidCopyFailedTitle: 'Não foi possível copiar o TXID',
    txidCopyFailedMessage: 'Tente novamente ou copie o TXID manualmente no card.',
    dismissToast: 'Entendi',
    showMore: 'Ver mais',
    showLess: 'Ver menos',
    viewMore: 'Ver Mais',
    tryAgain: 'Tentar novamente',
    loading: 'Carregando aposentadorias...',
    error: 'Erro ao carregar os retirements',
    noRetirements: 'Nenhuma aposentadoria disponível no momento'
  },
  benefitSharing: {
    eyebrow: 'Transparência',
    title: 'Compartilhamento de Benefícios',
    subtitle:
      'Distribuição do benefício econômico das compensações entre comunidade, Vert Ecotech e proprietário do projeto.',
    percentChartTitle: 'Distribuição percentual',
    creditsChartTitle: 'Distribuição em créditos compensados',
    centerDistribution: 'da distribuição',
    totalLabel: 'Total compensado',
    creditsUnit: 'créditos compensados',
    labels: {
      social: 'Social',
      vert: 'Vert Ecotech',
      owner: 'Proprietário',
    },
    legendAria: 'Legenda do compartilhamento de benefícios',
  },
  languageSelector: {
    selectLanguage: 'Selecione o Idioma',
    clickMap: 'Clique no mapa para alterar o idioma'
  },
  purchaseModal: {
    title: 'Solicitar Compra de Créditos',
    packageLabel: 'Pacote de Créditos',
    verifyPackage: 'Confira o pacote selecionado',
    fullName: 'Nome Completo',
    phone: 'Telefone',
    email: 'Email',
    phonePlaceholder: '(11) 99999-9999',
    namePlaceholder: 'Digite seu nome completo',
    emailPlaceholder: 'seu@email.com',
    cancel: 'Cancelar',
    submit: 'Enviar Solicitação',
    submitting: 'Enviando...',
    required: '*',
    errors: {
      nameLength: 'Nome deve ter pelo menos 3 caracteres',
      phoneLength: 'Telefone deve ter 10 ou 11 dígitos',
      emailInvalid: 'E-mail deve ser válido',
      formErrors: 'Por favor, corrija os erros no formulário.'
    },
    success: 'Solicitação enviada com sucesso! Entraremos em contato em breve.',
    error: 'Erro ao enviar solicitação. Tente novamente.',
    connectionError: 'Erro de conexão. Verifique sua internet e tente novamente.'
  },
  assetModal: {
    title: 'Detalhes do Pacote de Créditos',
    assetName: 'Nome do Pacote de Créditos',
    issuer: 'Emissor',
    standard: 'Padrão',
    assetType: 'Tipo de ativo',
    projectType: 'Tipo de projeto',
    vintage: 'Safra (vintage)',
    serialNumberBatch: 'Lote (número de série)',
    tokenAddress: 'Endereço do Token',
    txid: 'TXID',
    createdDate: 'Data de Criação',
    modifiedDate: 'Data de Modificação',
    createdBy: 'Criado por',
    assetId: 'Ativo',
    issuanceId: 'Emissão',
    projectId: 'Projeto',
    registry: 'Registro',
    creditsIssued: 'créditos emitidos',
    purchaseButton: 'Solicitar Compra de Créditos',
    loading: 'Carregando...',
    error: 'Erro ao carregar Detalhes do Pacote de Créditos',
    noAssetFound: 'Nenhum asset encontrado com esse nome',
    notAvailable: 'N/D',
    viewOnRegistry: 'Ver no registro Social Carbon',
  },
  b4CarbonSection: {
    originationPeriodLabel: 'Período de Originação',
    loading: 'Carregando projetos…',
    tryAgain: 'Tentar novamente',
    noPackages:
      'Nenhum pacote encontrado para o emissor configurado (Vert Ecotech).',
    packageDetails: 'Detalhes do Projeto',
    wilderSocialCarbonDetails: 'Wilder Earth - Social Carbon',
    purchaseRequest: 'Solicitar Reserva',
    detailsOnRegistry: 'Detalhes disponíveis no registro.',
    showcaseEyebrow: 'DESENVOLVIDOS PELA VERT ECOTECH',
    showcaseTitle: 'Nossos Projetos',
    loadErrorFallback: 'Falha ao carregar projetos',
    impactStandard: 'Padrão',
    impactVintage: 'Safra',
    impactCreditsIssued: 'créditos emitidos',
    impactRegistry: 'Registro',
    defaultAssetType: 'Carbono',
    packageFallbackPrefix: 'Pacote',
    viewPackageDetailsTitle: 'Ver detalhes do projeto',
    ctaLearnProject: 'Conheça o projeto',
    ctaBlockchainRegistry: 'Ver na Polygonscan - Registro blockchain',
    expandImageAria: 'Ver imagem completa',
    closeLightbox: 'Fechar',
    featuredProjects: [
      {
        protocolLogo: 'Protocolo Owie Bitioni - 1.png',
        protocolAlt: 'Protocolo Owie Bitioni',
        body:
          'O projeto nasce para proteger a integridade do território por meio de monitoramento contínuo e vigilância ativa, atuando diretamente na preservação de biodiversidade e no equilíbrio dos ecossistemas.',
        href: 'https://b4.capital/pt/projeto-owie-bitioni/',
        animalImage: 'Tamandua j crestani.png',
        animalAlt: 'Tamanduá — projeto Owie Bitioni',
        certificateImage: 'certificado-owie+bitioni.png',
        certificateAlt: 'Certificado do projeto Owie Bitioni',
        blockchainRegistryHref:
          'https://polygonscan.com/nft/0xc84fc3cdc3c6d0713ecc6008e50efcffc9b14b3b/1',
      },
      {
        protocolLogo: 'Protocolo Dowedi Mitir Final.png',
        protocolAlt: 'Protocolo Dowedi Mitir',
        body:
          'O projeto nasce para enfrentar o risco sistêmico das queimadas através de uma estratégia de vigilância ativa, unindo tecnologia de monitoramento e o saber ancestral para proteger a região.',
        href: 'https://b4.capital/pt/projeto-dowedi-mitir/',
        animalImage: 'Cervo do Pantanal Dowedi.png',
        animalAlt: 'Cervo-do-pantanal — projeto Dowedi Mitir',
        certificateImage: 'certificado-Dowedi+Mitir.png',
        certificateAlt: 'Certificado do projeto Dowedi Mitir',
        blockchainRegistryHref:
          'https://polygonscan.com/nft/0xfe7dee81b1a416068a5ce01f3489bd5c9996ae62/1',
      },
    ],
  },
  b4VertPage: {
    meta: {
      title: 'Vert Ecotech na B4, Bolsa de Ação Climática | Créditos de carbono e mercado de carbono',
      description:
        'Vert Ecotech homologada na B4, Bolsa de Ação Climática do Brasil. Mercado de carbono, créditos de carbono, transparência e blockchain.',
    },
    nav: {
      home: 'Início',
      about: 'Sobre a B4 - Bolsa de Ação Climática',
      partnership: 'Ecossistema e homologação',
      certificate: 'Certificado',
      compliance: 'Conformidade',
      projects: 'Projetos de carbono',
      benefitSharing: 'Compartilhamento de Benefícios',
      retirements: 'Aposentadorias',
      methodology: 'Metodologia e impacto',
      docs: 'Recursos e documentação',
      contact: 'Contato e dúvidas',
    },
    hero: {
      eyebrow: 'Empresa Homologada',
      titleBefore: 'Vert Ecotech na',
      lead:
        'Conectando projetos sustentáveis ao mercado global de carbono com transparência, tecnologia e impacto real.',
      ctaProjects: 'Conheça os Projetos',
      ctaPlatform: 'Acessar Plataforma B4',
      altSeal: 'Selo B4, Bolsa de Ação Climática',
    },
    about: {
      eyebrow: 'Institucional',
      h2: 'Sobre a B4, A Primeira Bolsa de Ação Climática',
      body1:
        'A B4 foi criada com o propósito de reduzir emissões de gases de efeito estufa e fortalecer o mercado de sustentabilidade por meio da tecnologia blockchain, garantindo rastreabilidade e segurança nas transações.',
      body2:
        'A plataforma conecta originadores de ativos sustentáveis a empresas que desejam iniciar ou evoluir sua jornada de ação climática.',
      btnOfficial: 'Página oficial da B4',
      trustTitle: 'Selo de confiança',
      altMini: 'Mini certificado — homologação B4',
    },
    partnership: {
      eyebrow: 'ecossistema de empresa na b4, bolsa de ação climática',
      h2: 'Vert Ecotech: Empresa Homologada',
      lead1:
        'A Vert Ecotech é uma empresa homologada na B4, atuando como desenvolvedora de projetos sustentáveis dentro do ecossistema. Essa união tem como objetivo promover, estruturar e acelerar a listagem de ativos climáticos, unindo expertise técnica, ambiental e estratégica.',
      allowsLead: 'A homologação permite:',
      cards: [
        {
          title: 'Desenvolvimento de Projetos de Sustentabilidade',
          text: 'Por meio da expertise Vert Ecotech, podemos desenvolver projetos que originem ativos climáticos em formato aceito pela B4.',
        },
        {
          title: 'Conformidade com o Padrão de Acreditação da B4',
          text:
            'Homologados pela B4, estruturamos projetos aderentes aos critérios exigidos, reduzindo fricções e trazendo mais eficiência aos projetos de due diligence e listagem.',
        },
        {
          title: 'Credibilidade e Confiança no Mercado Global',
          text: 'Os projetos passam a acessar um ecossistema global de Finanças Regenerativas, conectando empresas e instituições em suas jornadas de ação climática.',
        },
      ],
    },
    certificate: {
      eyebrow: 'Reconhecimento',
      h2: 'Certificado de Empresa Homologada na B4',
      body:
        'Certificado oficial de homologação, emitido para reforçar a credibilidade da companhia no ecossistema de empresas. A homologação confirma a aderência aos critérios da B4 e facilita a consulta pública do documento, com opção de visualização ou validação na plataforma oficial.',
      viewCert: 'Ver certificado',
      validate: 'Validar na B4',
      vertHomologated: 'Vert homologada na B4',
      altCert: 'Certificado empresa homologada B4',
    },
    governance: {
      eyebrow: 'Transparência',
      h2: 'Conformidade e governança',
      lead: 'Pilares de transparência, credibilidade e alinhamento ao mercado de ativos climáticos regulado e voluntário.',
      items: [
        {
          title: 'Adesão aos padrões B4',
          content:
            'Todos os projetos e operações seguem as diretrizes e regras do mercado de carbono, tanto no ambiente regulado quanto voluntário.',
        },
        {
          title: 'Mecanismos de Transparência',
          content: 'A Vert Ecotech garante:',
          list: [
            'Rastreabilidade via blockchain',
            'Auditorias independentes',
            'Registro público das transações',
          ],
        },
        {
          title: 'Estrutura de Governança',
          content: 'Descrição da estrutura interna responsável pelos projetos:',
        },
      ],
      teams: {
        quemSomosUrl: 'https://vertecotech.io/quem-somos/',
        technicalHeading:
          'Equipe técnica juntamente com o Comitê de Sustentabilidade',
        technicalMembers: [
          { name: 'André Jardini' },
          { name: 'Caroline Jerke' },
          { name: 'Izabel Melz Fleck' },
        ],
        projectMgmtHeading: 'Equipe de projetos',
        projectMgmtLinkLabel: 'Quem somos',
      },
    },
    methodology: {
      eyebrow: 'Impacto',
      h2: 'Metodologia e impacto',
      col1h: 'Metodologias utilizadas',
      col1items: ['Social Carbon', 'Demais padrões reconhecidos pelo mercado de carbono'],
      col2h: 'Benefícios ambientais',
      col2items: ['Estimativa de redução de CO₂', 'Conservação ambiental', 'Uso sustentável da terra'],
      col3h: 'Benefícios sociais e ESG',
      col3items: [
        'Impacto em comunidades locais',
        'Geração de emprego e renda',
        'Contribuição para os ODS (Objetivos de Desenvolvimento Sustentável)',
      ],
    },
    docs: {
      eyebrow: 'Acesso',
      h2: 'Recursos e documentação',
      accessBtn: 'Acessar',
      placeholderDriveSuffix: '— Briefing: pasta Google Drive',
      placeholderLink: 'Inserir link ou PDF externo',
      linkTitles: {
        creditVerification: 'Registro Wilder Earth',
        platformAccess: 'Acesso à plataforma B4',
        vertHomologated: 'Vert Ecotech homologada na B4',
        projectsListed: 'Projetos listados na B4',
        blockchain: 'Wilder Earth Blockchain Explorer',
      },
    },
    contact: {
      eyebrow: 'Fale conosco',
      h2: 'Contato e dúvidas',
      lead:
        'Contato do time Vert Ecotech — créditos de carbono, mercado de carbono e empresa homologada na B4, Bolsa de Ação Climática.',
      mailSubject: 'B4, Bolsa de Ação Climática / Créditos de Carbono',
      namePh: 'Nome',
      emailPh: 'E-mail',
      messagePh: 'Mensagem',
      submit: 'Enviar mensagem',
      sending: 'Enviando…',
      successTitle: 'Mensagem enviada!',
      successText:
        'Recebemos sua mensagem e nossa equipe entrará em contato o mais breve possível.',
      sendAnother: 'Enviar outra mensagem',
      mailBodyName: 'Nome: ',
      mailBodyEmail: 'Email: ',
      errors: {
        nome: 'Informe seu nome.',
        email: 'Informe seu e-mail.',
        mensagem: 'Descreva sua dúvida ou problema.',
        mensagemLong: 'Mensagem muito longa (máx. 10.000 caracteres).',
        rateLimit: 'Muitas tentativas. Aguarde um momento e tente de novo.',
        general: 'Não foi possível enviar. Tente novamente.',
        connection: 'Não foi possível conectar ao servidor.',
      },
    },
    footer: {
      climateExchange: 'Bolsa de Ação Climática do Brasil',
      top: 'Topo',
      legacyRef: 'Referência legada (API)',
    },
  },
  b4CertificatePage: {
    meta: {
      title: 'Certificado Vert Ecotech homologada na B4, Bolsa de Ação Climática | Mercado de carbono',
      description:
        'Certificado de empresa homologada na B4, Bolsa de Ação Climática. Valide o status na plataforma oficial.',
    },
    backLink: '← Vert Ecotech · B4, Bolsa de Ação Climática',
    h1Before: 'Certificado de Empresa Homologada na',
    h1Gradient: 'B4',
    lead:
      'Documento oficial de homologação B4, Bolsa de Ação Climática no idioma selecionado. Baixe o PNG abaixo.',
    previewLabel: 'Certificado — visualização',
    altCert: 'Certificado empresa homologada na B4',
    bodyValidation:
      'A validação pública do status pode ser feita diretamente na plataforma B4, garantindo autenticidade e transparência.',
    downloadLabel: 'Download — PNG',
    downloadFile: 'Certificado-Vert-B4-PT.png',
    downloadBtn: 'Baixar certificado',
    officialSite: 'Página oficial da B4',
    aboutH2: 'Sobre a homologação',
    aboutBody:
      'A homologação reconhece que a empresa cumpre os requisitos operacionais e de compliance definidos pela B4, Bolsa de Ação Climática para atuação na plataforma, incluindo trilhas de auditoria e governança alinhadas ao mercado de créditos de carbono.',
    footerBack: 'Voltar à página B4, Bolsa de Ação Climática / Vert Ecotech',
  },
};

